module.exports = __webpack_public_path__ + "static/sdglogo-a23bef8f4bd50df04ce65d3df79134bb.svg";